export const adminUsers = {
  'admin.users.title': 'Users Management',
  'admin.users.subtitle': 'Manage and monitor user accounts, statistics, and performance',
  'admin.users.loading': 'Loading...',
  'admin.users.error': 'Error loading users data',
  'admin.users.noData': 'No data available',
  'admin.users.cards.totalUsers.title': 'Total Users',
  'admin.users.cards.totalUsers.active': 'Active',
  'admin.users.cards.totalUsers.inactive': 'Inactive',
  'admin.users.cards.monthlyUsers.title': 'New Users This Month',
  'admin.users.cards.monthlyUsers.dailyRegistrations': 'Today\'s Registrations',
  'admin.users.cards.usersWithoutAccounts.title': 'Users Without Accounts',
  'admin.users.cards.usersWithoutAccounts.withInactiveAccounts': 'Users With Inactive Accounts',
  'admin.users.cards.countryDistribution.title': 'Top Countries',
  'admin.users.cards.countryDistribution.topCountry': 'Top Country',
  'admin.users.cards.countryDistribution.usersCount': 'Users Count',
  'admin.users.cards.countryDistribution.noData': 'No data available',
  'admin.users.cards.topEarnersCombined.title': 'Top Combined Earners',
  'admin.users.cards.topEarnersCombined.description': 'Trading + Commission Profits',
  'admin.users.cards.topEarnersAccounts.title': 'Top Trading Account Earners',
  'admin.users.cards.topEarnersAccounts.description': 'Trading Account Profits',
  'admin.users.cards.topEarnersCommissions.title': 'Top Commission Earners',
  'admin.users.cards.topEarnersCommissions.description': 'Community Commission Profits',
  'admin.users.tables.recent.title': 'Recent Users (Last 7 Days)',
  'admin.users.tables.inactive.title': 'Inactive Users',
  'admin.users.tables.no_accounts.title': 'Users Without Accounts',
  'admin.users.tables.inactive_accounts.title': 'Users with Inactive Accounts',
  'admin.users.tables.columns.username': 'Username',
  'admin.users.tables.columns.name': 'Name',
  'admin.users.tables.columns.country': 'Country',
  'admin.users.tables.columns.status': 'Status',
  'admin.users.tables.columns.joinedAt': 'Joined At',
  'admin.users.tables.columns.accountCreationDate': 'Account Creation',
  'admin.users.tables.columns.accountNumber': 'Account Number',
  'admin.users.tables.columns.accountStatus': 'Account Status',
  'admin.users.tables.columns.actions': 'Actions',
  'admin.users.tables.status.active': 'Active',
  'admin.users.tables.status.inactive': 'Inactive',
  'admin.users.tables.accountStatus.active': 'Active',
  'admin.users.tables.accountStatus.inactive': 'Inactive',
  'admin.users.tables.accountStatus.pending': 'Pending',
  'admin.users.tables.accountStatus.suspended': 'Suspended',
  'admin.users.tables.accountStatus.closed': 'Closed',
  'admin.users.tables.pagination.previous': 'Previous',
  'admin.users.tables.pagination.next': 'Next',
  'admin.users.tables.pagination.loadMore': 'Load More',
  'admin.users.tables.pagination.showing': 'Showing',
  'admin.users.tables.pagination.of': 'of',
  'admin.users.tables.pagination.results': 'results',
  'admin.users.tables.pagination.page': 'Page',
  'admin.users.tables.error': 'Error loading table data',
  'admin.users.tables.noData': 'No data available',
  'admin.users.tables.noAccount': 'No Account',
  'admin.users.tables.unknown': 'Unknown',
  'admin.users.tables.viewProfile': 'View Profile',
  // Search page translations
  'admin.users.search.title': 'User Search',
  'admin.users.search.subtitle': 'Search and find users by various criteria',
  'admin.users.search.form.userInfo.label': 'User Information',
  'admin.users.search.form.userInfo.placeholder': 'Search by username, name, email, or phone...',
  'admin.users.search.form.country.label': 'Country',
  'admin.users.search.form.country.placeholder': 'Select a country...',
  'admin.users.search.form.country.all': 'All Countries',
  'admin.users.search.form.searchButton': 'Search',
  'admin.users.search.form.clearButton': 'Clear',
  'admin.users.search.results.title': 'Search Results',
  'admin.users.search.results.noResults': 'No users found matching your criteria',
  'admin.users.search.results.loading': 'Searching users...',
  'admin.users.search.results.error': 'Error searching users',
  'admin.users.search.results.showEmail': 'Show Email',
  'admin.users.search.results.hideEmail': 'Hide Email',
  'admin.users.search.results.showPhone': 'Show Phone',
  'admin.users.search.results.hidePhone': 'Hide Phone',
  'admin.users.search.results.columns.email': 'Email',
  'admin.users.search.results.columns.phone': 'Phone',
  
  // Profile page
  'admin.users.profile.title': 'User Profile',
  'admin.users.profile.subtitle': 'View detailed user information and settings',
  'admin.users.profile.error.userNotFound': 'User not found. The specified username does not exist.',
  'admin.users.profile.loading': 'Loading user profile...',
  
  // Profile information section
  'admin.users.profile.info.title': 'Profile Information',
  'admin.users.profile.info.username': 'Username',
  'admin.users.profile.info.name': 'Name',
  'admin.users.profile.info.status': 'User Status',
  'admin.users.profile.info.memberSince': 'Member Since',
  'admin.users.profile.info.sponsor': 'Sponsor',
  'admin.users.profile.info.referralLink': 'Referral Link',
  'admin.users.profile.info.commissionModel': 'Commission Model',
'admin.users.profile.info.country': 'Country',
  'admin.users.profile.info.domain': 'Domain',
  'admin.users.profile.info.internalCommissionModel': 'Internal Commission Model',
  'admin.users.profile.info.communityLevel': 'Community Level',
  'admin.users.profile.info.genealogyTree': 'Community Genealogy Tree',
  'admin.users.profile.info.openUserTree': 'Open User\'s Tree',
  'admin.users.profile.info.copyReferralLink': 'Copy Referral Link',
  'admin.users.profile.info.viewSponsor': 'View Sponsor Profile',
  'admin.users.profile.info.noData': 'Profile information is not available.',
  
  // User status editing
  'admin.users.profile.status.editButton': 'Edit Status',
  'admin.users.profile.status.saveButton': 'Save',
  'admin.users.profile.status.cancelButton': 'Cancel',
  'admin.users.profile.status.saving': 'Saving...',
  'admin.users.profile.status.active': 'Active',
  'admin.users.profile.status.inactive': 'Inactive',
  'admin.users.profile.status.updateSuccess': 'Status Updated',
  'admin.users.profile.status.updateSuccessDescription': 'User status has been successfully updated.',
  'admin.users.profile.status.updateError': 'Update Failed',
  'admin.users.profile.status.updateErrorDescription': 'Failed to update user status. Please try again.',
  
  // Private information section
  'admin.users.profile.private.title': 'Private Information',
  'admin.users.profile.private.subtitle': 'Confidential user personal details',
  'admin.users.profile.private.email': 'Email',
  'admin.users.profile.private.phone': 'Phone Number',
  'admin.users.profile.private.gender': 'Gender',
  'admin.users.profile.private.noData': 'Private information is not available.',
  
  // Payment methods section
  'admin.users.profile.payment.title': 'Payment Methods',
  'admin.users.profile.payment.subtitle': 'User\'s configured payment options',
  'admin.users.profile.payment.crypto.title': 'Crypto Wallet',
  'admin.users.profile.payment.crypto.network': 'Network',
  'admin.users.profile.payment.crypto.currency': 'Currency',
  'admin.users.profile.payment.crypto.address': 'Address',
  'admin.users.profile.payment.noData': 'No payment methods configured.',

  // User Accounts Section
  profileUserAccounts: 'User Accounts',
  profileUserAccountsSubtitle: 'Trading accounts and investment details',
  profileAccountsTableAccountNumber: 'Account Number',
  profileAccountsTableAccountStatus: 'Account Status',
  profileAccountsTableAccountType: 'Account Type',
  profileAccountsTableProgramPercent: 'Program Percent',
  profileAccountsTableBalance: 'Balance',
  profileAccountsTableCreationDate: 'Account Creation',
  profileAccountsTableNoData: 'No accounts data available',
  profileAccountsTableError: 'Error loading accounts data',

  // User Earnings Section
  profileUserEarnings: 'User Earnings Information',
  profileUserEarningsSubtitle: 'Comprehensive earnings and profit overview',
  profileEarningsError: 'Error loading earnings data',
  profileEarningsNoData: 'No earnings data available',
  
  // Admin profile earnings keys
  'admin.users.profile.earnings.title': 'User Earnings Information',
  'admin.users.profile.earnings.subtitle': 'Comprehensive earnings and profit overview',
  
  // Historic Earnings Section
  'admin.users.profile.historicEarnings.title': 'User\'s Historic Earnings Information',
  'admin.users.profile.historicEarnings.subtitle': 'Complete historical view of accounts and commission earnings',
  'admin.users.profile.historicEarnings.error.userIdRequired': 'User ID is required to load earnings data',
  'admin.users.profile.historicEarnings.accountsHistory.title': 'Accounts Profit History',
  'admin.users.profile.historicEarnings.accountsHistory.subtitle': 'Historical profit data from user investment accounts',
  'admin.users.profile.historicEarnings.accountsHistory.error': 'Error loading accounts profit history',
  'admin.users.profile.historicEarnings.commissionsHistory.title': 'Commission Earnings History',
  'admin.users.profile.historicEarnings.commissionsHistory.subtitle': 'Historical commission earnings from referral network',
  'admin.users.profile.historicEarnings.commissionsHistory.error': 'Error loading commission earnings history',
  
  // Payment History Section
  'admin.users.profile.paymentHistory.title': 'User\'s Payment History',
  'admin.users.profile.paymentHistory.subtitle': 'Complete record of commission payments and transactions',
  'admin.users.profile.paymentHistory.error.userIdRequired': 'User ID is required to load payment data',
  'admin.users.profile.paymentHistory.error.loadingData': 'Error loading payment history data',

  // Admin Community Levels
  'admin.users.communityLevels.title': 'Community Levels',
  'admin.users.communityLevels.subtitle': 'Explore community structure by hierarchical levels',
  'admin.users.communityLevels.targetUser': 'Target User',
  'admin.users.communityLevels.level': 'Level',
  'admin.users.communityLevels.members': 'members',
  'admin.users.communityLevels.total': 'total',
  'admin.users.communityLevels.active': 'Active',
  'admin.users.communityLevels.inactive': 'Inactive',
  'admin.users.communityLevels.treeLevel': 'Tree Level',
  'admin.users.communityLevels.directReferrals': 'Direct Referrals',
  'admin.users.communityLevels.memberSince': 'Member Since',
  'admin.users.communityLevels.username': 'Username',
  'admin.users.communityLevels.name': 'Name',
  'admin.users.communityLevels.country': 'Country',
  'admin.users.communityLevels.joinDate': 'Join Date',
  'admin.users.communityLevels.status': 'Status',
  'admin.users.communityLevels.loading': 'Loading...',
  'admin.users.communityLevels.loadMore': 'Load More',
  'admin.users.communityLevels.noMembers': 'No members found for this level',
  'admin.users.communityLevels.errorLoading': 'Error loading level data',
  'admin.users.communityLevels.errorLoadingData': 'Error loading community data',
  'admin.users.communityLevels.userNotFound': 'User not found',
  'admin.users.communityLevels.noCommunityData': 'No community data available',
  'admin.users.communityLevels.filters': 'Filters',
  'admin.users.communityLevels.statusFilter': 'Status Filter',
  'admin.users.communityLevels.rankFilter': 'Rank Filter',
  'admin.users.communityLevels.allStatuses': 'All Statuses',
  'admin.users.communityLevels.allRanks': 'All Ranks',
  'admin.users.communityLevels.communityStructure': 'Community Structure',
};